import { render, staticRenderFns } from "./DraftOrder.vue?vue&type=template&id=62546b2d"
import script from "./DraftOrder.vue?vue&type=script&lang=js"
export * from "./DraftOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports